export default `
mutation InitClient($identityId: ID!, $notifications: NotificationsInput) {
  initClient(identityId: $identityId, notifications: $notifications) {
    void
  }
}
`;